import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";
import { actions } from "assets/properties/properties";
const RiskCategoryMasterCreate = ({ props, classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [minAuditedLtv, setMinAuditedLtv] = useState("");
  const [minAuditedLtvState, setMinAuditedLtvState] = useState(false);
  const [maxAuditedLtv, setMaxAuditedLtv] = useState("");
  const [maxAuditedLtvState, setMaxAuditedLtvState] = useState(false);
  const [AuditedLtvScore, setAuditedLtvScore] = useState("");
  const [AuditedLtvScoreState, setAuditedLtvScoreState] = useState(false);
  const [minMarketLtv, setMinMarketLtv] = useState("");
  const [minMarketLtvState, setMinMarketLtvState] = useState(false);
  const [maxMarketLtv, setMaxMarketLtv] = useState("");
  const [maxMarketLtvState, setMaxMarketLtvState] = useState(false);
  const [MarketLtvScore, setMarketLtvScore] = useState("");
  const [MarketLtvScoreState, setMarketLtvScoreState] = useState(false);
  const [minDpd, setMinDpd] = useState("");
  const [minDpdState, setMinDpdState] = useState(false);
  const [maxDpd, setMaxDpd] = useState("");
  const [maxDpdState, setMaxDpdState] = useState(false);
  const [DpdScore, setDpdScore] = useState("");
  const [DpdScoreState, setDpdScoreState] = useState(false);
  const viewPage = window.location.href.includes("createView");
  const [riskCategoryData,setRiskCategoryData]= useState([]);
  const [disableButton,setDisabledButton]=useState(false);

  useEffect(() => {
    (async () => {
      if (params?.id) {
        setCallInProgress(true);
        try {
          // Get Data from API
          const result = await apiHandler({
            url: endpoint.RISK_CATEGORY_FIND_ALL,
            authToken: authToken,
          });
          if (result?.data?.length) {
            const item = result?.data?.find((item) => Number(item?.id) === Number(params?.id));
            if (item) {
              setMinAuditedLtv(Number(item?.minAuditedLtv) || 0);
              setMaxAuditedLtv(Number(item?.maxAuditedLtv) || 0);
              setAuditedLtvScore(Number(item?.auditLtvScore) || 0);
              setMinMarketLtv(Number(item?.minMarketLtv) || 0);
              setMaxMarketLtv(Number(item?.maxMarketLtv) || 0);
              setMarketLtvScore(Number(item?.marketLtvScore) || 0);
              setMinDpd(Number(item?.minDpd) || 0);
              setMaxDpd(Number(item?.maxDpd) || 0);
              setDpdScore(Number(item?.dpdScore) || 0);
            }
          }
        } finally {
          setCallInProgress(false);
        }
      }
    })();
  }, []);  
  useEffect(()=>{
    findRiskCategoryData();
  },[])
  const findRiskCategoryData = async () => {
    const result = await apiHandler({
      url: endpoint.RISK_CATEGORY_AND_SCORE_DATA,
      authToken: authToken,
    });
    if(result?.data?.loanRiskCategories?.length  > 0){
      setRiskCategoryData(result?.data?.loanRiskCategories);
    }
  }

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const editInformation = async () => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.RISK_CATEGORY_UPDATE + params?.id,
        method: "PUT",
        authToken: authToken,
        data: {
          minAuditedLtv: minAuditedLtv,
          maxAuditedLtv: maxAuditedLtv,
          auditLtvScore:AuditedLtvScore,
          minMarketLtv: minMarketLtv,
          maxMarketLtv: maxMarketLtv,
          marketLtvScore:MarketLtvScore,
          minDpd: minDpd,
          maxDpd: maxDpd,
          dpdScore:DpdScore,
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return actions.error;
      } else {
        return actions.success;
      }
    }
  };
  const isValidated = () => {
    const fields = [
      { value: maxAuditedLtv, setter: setMaxAuditedLtvState },
      { value: minAuditedLtv, setter: setMinAuditedLtvState },
      { value: AuditedLtvScore, setter: setAuditedLtvScoreState },
      { value: minMarketLtv, setter: setMinMarketLtvState },
      { value: maxMarketLtv, setter: setMaxMarketLtvState },
      { value: MarketLtvScore, setter: setMarketLtvScoreState },
      { value: minDpd, setter: setMinDpdState },
      { value: maxDpd, setter: setMaxDpdState },
      { value: DpdScore, setter: setDpdScoreState },
    ];
  
    let isValid = true;
  
    // Check for each group
    const checkGroup = (group) => {
      const filled = group.some(({ value }) => value !== "");
      group.forEach(({ value, setter }) => {
        if (filled && value === "") {
          setter(true);
          isValid = false;
        } else {
          setter(false);
        }
      });
    };
  
    // Define groups
    const auditedLtvGroup = fields.slice(0, 3);
    const marketLtvGroup = fields.slice(3, 6);
    const dpdGroup = fields.slice(6, 9);
  
    // Validate each group
    checkGroup(auditedLtvGroup);
    checkGroup(marketLtvGroup);
    checkGroup(dpdGroup);
  
    // Validate max values against min values only if both are filled
    if (maxAuditedLtv && minAuditedLtv && Number(maxAuditedLtv) < Number(minAuditedLtv)) {
      toastUpdate(
        "Error",
        `Max Audit LTV should be greater than or equal to ${minAuditedLtv}`,
        true
      );
      return false;
    }
  
    if (maxMarketLtv && minMarketLtv && Number(maxMarketLtv) < Number(minMarketLtv)) {
      toastUpdate(
        "Error",
        `Max Market LTV should be greater than or equal to ${minMarketLtv}`,
        true
      );
      return false;
    }
    console.log(maxDpd,minDpd,"DPDPPDPDPDP")
    if (maxDpd && minDpd && Number(maxDpd) < Number(minDpd)) {
      toastUpdate(
        "Error",
        `Max DPD should be greater than or equal to ${minDpd}`,
        true
      );
      return false;
    }
  
    return isValid;
  };  

  const saveInformation = async () => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.RISK_CATEGORY_CREATE,
        method: "POST",
        authToken: authToken,
        data: {
          minAuditedLtv: minAuditedLtv,
          maxAuditedLtv: maxAuditedLtv,
          auditLtvScore:AuditedLtvScore,
          minMarketLtv: minMarketLtv,
          maxMarketLtv: maxMarketLtv,
          marketLtvScore:MarketLtvScore,
          minDpd: minDpd,
          maxDpd: maxDpd,
          dpdScore:DpdScore,
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return actions.error;
      } else {
        return actions.success;
      }
    }
  };
  const handleDiscrepancySubmit = async (event) => {
    toastUpdate("", "", false);
    let status = "";
    if (params?.id) {
      status = await editInformation();
    } else {
      status = await saveInformation();
    }
    if (status === actions.success) {
      const message = params?.id
        ? "Risk Category updated successfully!"
        : "Risk Category created successfully!";
      toastUpdate("Success", message, true);
      setRedirectURL(`/coreservice/riskCategoryTab`);
    }
  };
  const handleCancel = () => {
    navigate("/coreservice/riskCategoryTab");
  };

  const title = viewPage ? "View Risk Category" : "Edit Risk Category";

  const handleMinAuditedLtv = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex?.test(e)) {
      setMinAuditedLtv(e);
    }
  };
  const handleMaxAuditedLtv = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex?.test(e)) {
      setMaxAuditedLtv(e);
    }
  };
  const handleAuditedLtvScore = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex?.test(e)) {
      setAuditedLtvScore(e);
    }
  };
  const handleMinMaketLtv = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex?.test(e)) {
      setMinMarketLtv(e);
    }
  };
  const handleMaxMarketLtv = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex?.test(e)) {
      setMaxMarketLtv(e);
    }
  };
  const handleMarketLtvScore = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex?.test(e)) {
      setMarketLtvScore(e);
    }
  };
  const handleMinDpd = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex?.test(e)) {
      setMinDpd(e);
    }
  };
  const handleMaxDpd = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex?.test(e)) {
      setMaxDpd(e);
    }
  };
  const handleDpdScore = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex?.test(e)) {
      setDpdScore(e);
    }
  };
  const handleBlur = async (e, name) => {
    if(riskCategoryData?.length < 1){
      return;
    }
    const value = Number(e);
  
    // Error handling for value limits
    if ((name === "minAudited" || name === "maxAudited" || name === "minMarket" || name === "maxMarket") && value > 150) {
      toastUpdate("Error", `Value can't be greater than 150`, true);
      setDisabledButton(true);
      return;
    }
  
    if ((name === "auditedLtv" || name === "marketLtv" || name === "dpdLtv") && value > 100) {
      toastUpdate("Error", `Value can't be greater than 100`, true);
      setDisabledButton(true);
      return;
    }
  
    if (name === "maxAudited" && value < minAuditedLtv) {
      toastUpdate("Error", `Max Audited Ltv Value can't be smaller than Min Audited Ltv`, true);
      setDisabledButton(true);
      return;
    }
  
    if (name === "maxMarket" && value < minMarketLtv) {
      toastUpdate("Error", `Max Market Ltv Value can't be smaller than Min Market Ltv`, true);
      setDisabledButton(true);
      return;
    }
  
    if (name === "maxDpd" && value < minDpd) {
      toastUpdate("Error", `Max DPD Ltv Value can't be smaller than Min DPD Ltv`, true);
      setDisabledButton(true);
      return;
    }
  
    let filteredData = [];
    if (params?.id) {
      filteredData = riskCategoryData?.filter((item) => item?.id !== Number(params?.id));
    } else {
      filteredData = riskCategoryData;
    }

  
    // Compare with riskCategoryData using a for loop
    for (let i = 0; i < filteredData?.length; i++) {
      const item = filteredData[i];
  
      if (name === "minAudited" && value <= item?.maxAuditedLtv) {
        toastUpdate("Error", `Min Audited LTV can't be smaller than (${item?.maxAuditedLtv})`, true);
        setDisabledButton(true);
        return;
      }
      
      if (name === "maxAudited" && value <= item?.maxAuditedLtv) {
        toastUpdate("Error", `Max Audited LTV should be greater than (${item?.maxAuditedLtv})`, true);
        setDisabledButton(true);
        return;
      }
      
      if (name === "minMarket" && value <= item?.maxMarketLtv) {
        toastUpdate("Error", `Min Market LTV can't be smaller than (${item?.maxMarketLtv})`, true);
        setDisabledButton(true);
        return;
      }
      
      if (name === "maxMarket" && value <= item?.maxMarketLtv) {
        toastUpdate("Error", `Max Market LTV should be greater than (${item?.maxMarketLtv})`, true);
        setDisabledButton(true);
        return;
      }
      
      if (name === "minDpd" && value <= item?.maxDpd) {
        toastUpdate("Error", `Min DPD can't be smaller than (${item?.maxDpd})`, true);
        setDisabledButton(true);
        return;
      }
      
      if (name === "maxDpd" && value <= item?.maxDpd) {
        toastUpdate("Error", `Max DPD should be greater than (${item?.maxDpd})`, true);
        setDisabledButton(true);
        return;
      }
      
      if (name === "auditedLtv" && value === item?.auditLtvScore) {
        toastUpdate("Error", `Audited LTV Score already present`, true);
        setDisabledButton(true);
        return;
      }
      
      if (name === "marketLtv" && value === item?.marketLtvScore) {
        toastUpdate("Error", `Market LTV Score already present`, true);
        setDisabledButton(true);
        return;
      }
      
      if (name === "dpdLtv" && value === item?.dpdScore) {
        toastUpdate("Error", `DPD Score already present`, true);
        setDisabledButton(true);
        return;
      }
    }
    setDisabledButton(false);
  };
  
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={params?.id ? title : "Create Risk Category"}
          button1={!viewPage && "Save"}
          button2=" Cancel"
          button1click={!viewPage && handleDiscrepancySubmit}
          button2click={handleCancel}
          disabled1={disableButton}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Min Audited Ltv"
              required
              id="minAuditedLtv"
              value={minAuditedLtv}
              setState={handleMinAuditedLtv}
              error={minAuditedLtvState}
              setError={setMinAuditedLtvState}
              disabled={viewPage}
              setBlur={(e) => handleBlur(e, 'minAudited')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Max Audited Ltv"
              required
              id="maxAuditedLtv"
              value={maxAuditedLtv}
              setState={handleMaxAuditedLtv}
              error={maxAuditedLtvState}
              setError={setMaxAuditedLtvState}
              disabled={viewPage}
              setBlur={(e) => handleBlur(e, 'maxAudited')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Audited Ltv Score(Max 100)"
              required
              id="AuditedLtvScore"
              value={AuditedLtvScore}
              setState={handleAuditedLtvScore}
              error={AuditedLtvScoreState}
              setError={setAuditedLtvScoreState}
              disabled={viewPage}
              setBlur={(e) => handleBlur(e, 'auditedLtv')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Min Market Ltv*"
              id="minMarketLtv"
              value={minMarketLtv}
              setState={handleMinMaketLtv}
              error={minMarketLtvState}
              setError={setMinMarketLtvState}
              disabled={viewPage}
              setBlur={(e) => handleBlur(e, 'minMarket')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Max Market Ltv*"
              id="maxMarketLtv"
              value={maxMarketLtv}
              setState={handleMaxMarketLtv}
              error={maxMarketLtvState}
              setError={setMaxMarketLtvState}
              disabled={viewPage}
              setBlur={(e) => handleBlur(e, 'maxMarket')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Market Ltv Score(Max 100)*"
              id="MarketLtvScore"
              value={MarketLtvScore}
              setState={handleMarketLtvScore}
              error={MarketLtvScoreState}
              setError={setMarketLtvScoreState}
              disabled={viewPage}
              setBlur={(e) => handleBlur(e, 'marketLtv')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Min Dpd*"
              id="minDpd"
              value={minDpd}
              setState={handleMinDpd}
              error={minDpdState}
              setError={setMinDpdState}
              disabled={viewPage}
              setBlur={(e) => handleBlur(e, 'minDpd')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Max Dpd*"
              id="maxDpd"
              value={maxDpd}
              setState={handleMaxDpd}
              error={maxDpdState}
              setError={setMaxDpdState}
              disabled={viewPage}
              setBlur={(e) => handleBlur(e, 'maxDpd')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Dpd Score(Max 100)*"
              id="DpdScore"
              value={DpdScore}
              setState={handleDpdScore}
              error={DpdScoreState}
              setError={setDpdScoreState}
              disabled={viewPage}
              setBlur={(e) => handleBlur(e, 'dpdLtv')}
            />
          </Grid>
        </Grid>
      </Grid>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default RiskCategoryMasterCreate;
